import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { AuthService, DismissedPopupKeywords, Kindergarten, KindergartenContract } from '@isophi/core-legacy';
import { toSnakecaseFun } from '@app/core/utils/object.utils';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class KindergartenService {
  private readonly authService = inject(AuthService);
  private kindergartenSubject = new BehaviorSubject<Kindergarten | null>(null);
  kindergarten$ = this.kindergartenSubject.asObservable();

  constructor(private httpClient: HttpClient) {}

  get loggedKindergarten(): Kindergarten | null {
    return this.kindergartenSubject.value;
  }

  async loadLoggedKindergarten(): Promise<void> {
    const url = `${environment.teacherAPI}/general/logged-kindergarten/`;
    const response = await firstValueFrom(this.httpClient.get<KindergartenContract>(url));
    const kindergarten = Kindergarten.deserialize(toSnakecaseFun(response));
    this.kindergartenSubject.next(kindergarten);
  }

  dismissTeacherPopup(popup: DismissedPopupKeywords): Promise<any> {
    const url = `${environment.teacherAPI}/popup-dismissals/`;

    return firstValueFrom(this.httpClient.post(url, { popup_keyword: popup })).then(() => {
      this.authService.dismissUserPopup(popup);
    });
  }

  clear(): void {
    this.kindergartenSubject.next(null);
  }
}
